import { render, staticRenderFns } from "./InfoQuestionaryFooter.vue?vue&type=template&id=0fa508a0&scoped=true&"
import script from "./InfoQuestionaryFooter.vue?vue&type=script&lang=ts&"
export * from "./InfoQuestionaryFooter.vue?vue&type=script&lang=ts&"
import style0 from "./InfoQuestionaryFooter.vue?vue&type=style&index=0&id=0fa508a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa508a0",
  null
  
)

export default component.exports